//#region ../base/util/environment.ts
function getEnvVariable(variable) {
	if (typeof window !== "undefined") try {
		return import.meta.env[variable];
	} catch (error) {}
	if (typeof process !== "undefined" && "versions" in process && typeof process.versions === "object" && "node" in process.versions && typeof process.versions.node === "string") return process.env[variable];
	throw new Error("Unsupported environment");
}
function getDomain() {
	if (typeof window === "undefined") return void 0;
	return window.location.hostname.includes("jwplayer.com") ? "jwplayer.com" : void 0;
}

//#endregion
export { getDomain, getEnvVariable };
//# sourceMappingURL=environment.js.map